import { computed, defineComponent, ref } from '@vue/composition-api';
import { QuestionType, SURVEY_ANSWER_SEPARATOR, updateSurveyUserQuestionStatus, SurveyUserStatus, } from '@/api/v2/requests/surveys';
import { Icon, IconSize } from '@/components/Icon';
import { mdiCheck, mdiClose } from '@mdi/js';
import SurveyStatusBadge from '@/views/Brand/Surveys/_components/SurveyStatusBadge.vue';
import SurveyFileAnswer from '@/views/Brand/Surveys/Users/_components/SurveyFileAnswer.vue';
import ImageModal from '@/components/Modal/ImageModal.vue';
import { getSurveyImageUrls } from './survey-image-urls';
export default defineComponent({
    name: 'SurveyQuestionReadonly',
    components: {
        Icon,
        SurveyStatusBadge,
        SurveyFileAnswer,
        ImageModal,
    },
    props: {
        idx: { type: Number, required: true },
        question: {
            type: Object,
            required: true,
        },
        commentAuthorFullName: {
            type: String,
            default: null,
        },
        canManageStatus: {
            type: Boolean,
            default: false,
        },
        surveyUserId: {
            type: String,
            default: null,
        },
        questionStatus: {
            type: String,
            default: null,
        },
    },
    setup(props, ctx) {
        const id = computed(() => `q-${props.idx}`);
        const imageUrls = computed(() => getSurveyImageUrls(props.question.fileUrl));
        const fullQuestionImageUrl = computed(() => imageUrls.value.fullUrl);
        const thumbnailQuestionImageUrl = computed(() => imageUrls.value.thumbnailUrl);
        const files = ref(props.question.value && props.question.type === QuestionType.FILE
            ? props.question.value.split(SURVEY_ANSWER_SEPARATOR).filter(Boolean)
            : []);
        const attachmentFiles = computed(() => {
            if (!props.question.attachmentFile)
                return [];
            return props.question.attachmentFile
                .split(SURVEY_ANSWER_SEPARATOR)
                .filter(Boolean);
        });
        const handleChangeStatus = async (nextStatus) => {
            if (!props.surveyUserId)
                return;
            const statusToSet = nextStatus === props.questionStatus
                ? SurveyUserStatus.IN_VERIFICATION
                : nextStatus;
            try {
                ctx.emit('update:is-loading', { id, value: true });
                await updateSurveyUserQuestionStatus(props.surveyUserId, String(props.idx), {
                    status: statusToSet,
                });
                ctx.emit('status-changed', props.idx, statusToSet);
            }
            catch (err) {
                ctx.root.$toast.error(ctx.root.$t('surveys.error'));
            }
            finally {
                ctx.emit('update:is-loading', { id, value: false });
            }
        };
        return {
            id,
            files,
            attachmentFiles,
            QuestionType,
            handleChangeStatus,
            mdiCheck,
            mdiClose,
            IconSize,
            fullQuestionImageUrl,
            thumbnailQuestionImageUrl,
        };
    },
});
